var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shows)?_c('div',[_c('img',{staticClass:"character left",class:_vm.leftClass,attrs:{"src":this.left}}),_c('img',{staticClass:"character right",class:_vm.rightClass,attrs:{"src":this.right}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }